import { PATHS } from "@/lib/router";
import SettingsPage from "./pages/SettingsPage";

export const settingsRoutes = [
  {
    path: PATHS.SETTINGS,
    element: <SettingsPage />,
  },
];
